import { Router } from '@angular/router';
import { Component, OnInit, Input, Output } from '@angular/core';

@Component({
  selector: 'app-card-box',
  templateUrl: './card-box.component.html',
  styleUrls: ['./card-box.component.scss'],
})
export class CardBoxComponent implements OnInit {
  @Input() imagem: string;
  @Input() help: string;
  @Input() texto: string;
  @Input() classe: string;
  @Input() titulo: string;
  @Input() tamanho: string;
  @Input() numero: number;
  @Input() carregando: boolean;
  @Input() erros: number;
  @Input() link: string; //link relativo ou absoluto
  @Input() textoLink: string; //texto para o botão

  constructor(private router: Router) {}

  ngOnInit() {}

  navegar() {
    if (this.erros == 0 && this.link) {
      ////console.log('navegar para: ' + this.routerLink);
      this.router.navigate([this.link]);
    }
  }
}
